import "core-js/modules/es.array.concat.js";
import _typeof from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/typeof";
import Boss from '@tencent/vft-common/Boss';
import Monitor from './Monitor';

var _boss = new Boss({
  bossId: 479,
  pwd: 0
});

var FATAL = 5,
    ERROR = 4,
    WARNING = 3,
    INFO = 2,
    DEBUG = 1;
var DEFAULT_BIZ_ID = 'film_front_error';

var extend = Object.assign || function (dest, source) {
  if (!source || _typeof(source) != 'object' || _typeof(dest) != 'object') {
    return dest;
  }

  for (var k in source) {
    dest[k] = source[k];
  }

  return dest;
};

var _bizId, _pageId;
/**
 * 初始化
 * @param {String} bizId  - 项目id，默认值为 film_front_error [可选]
 * @param {String} pageId - 页面id，用于区分不同的业务
 */


function init(_ref) {
  var _ref$bizId = _ref.bizId,
      bizId = _ref$bizId === void 0 ? DEFAULT_BIZ_ID : _ref$bizId,
      pageId = _ref.pageId;

  if (!pageId) {
    throw new Error('[@tencent/vft-monitor.Monitor.init]pageId is required');
  }

  _bizId = bizId;
  _pageId = pageId;
  window.addEventListener('error', function (e) {
    fatal({
      modId: 'uncatch_error',
      msg: e.message,
      file: e.filename,
      line: e.lineno
    });
  });
  window.addEventListener('unhandledrejection', function (_ref2) {
    var reason = _ref2.reason;
    fatal({
      modId: 'uncatch_error',
      msg: reason.msg,
      code: reason.code
    });
  });
}

function _report(_ref3) {
  var sBiz = _ref3.sBiz,
      _ref3$bizId = _ref3.bizId,
      bizId = _ref3$bizId === void 0 ? _bizId : _ref3$bizId,
      _ref3$pageId = _ref3.pageId,
      pageId = _ref3$pageId === void 0 ? _pageId : _ref3$pageId,
      _ref3$modId = _ref3.modId,
      modId = _ref3$modId === void 0 ? '' : _ref3$modId,
      msg = _ref3.msg,
      file = _ref3.file,
      line = _ref3.line,
      fn = _ref3.fn,
      level = _ref3.level,
      code = _ref3.code,
      operate = _ref3.operate,
      uid = _ref3.uid;

  if (!sBiz && (!bizId || !pageId || !modId)) {
    return;
  }

  if (!sBiz) {
    sBiz = "".concat(bizId, ".").concat(pageId, ".").concat(modId);
  }

  _boss.report({
    sBiz: sBiz,
    errmsg: msg,
    srcfile: file,
    srcline: line,
    func: fn,
    level: level,
    iSta: code,
    sOp: operate,
    iQQ: uid
  });
}
/**
 * 错误级别 -	fatal
 * @param {Object} params 
 * @param {String} [params.modId] - 子模块，用于区分具体的模块报错
 * @param {String} [params.msg] 错误信息
 * @param {Number} [params.code] 错误码
 */


function fatal(params) {
  _report(extend(params, {
    level: FATAL
  }));
}
/**
 * 错误级别 -	error
 * @param {Object} params 
 * @param {String} [params.modId] - 子模块，用于区分具体的模块报错
 * @param {String} [params.msg] 错误信息
 * @param {Number} [params.code] 错误码
 */


function error(params) {
  _report(extend(params, {
    level: ERROR
  }));
}
/**
 * 错误级别 -	警告
 * @param {Object} params 
 * @param {String} [params.modId] - 子模块，用于区分具体的模块报错
 * @param {String} [params.msg] 错误信息
 * @param {Number} [params.code] 错误码
 */


function warn(params) {
  _report(extend(params, {
    level: WARNING
  }));
}
/**
 * 错误级别 -	info
 * @param {Object} params 
 * @param {String} [params.modId] - 子模块，用于区分具体的模块报错
 * @param {String} [params.msg] 错误信息
 * @param {Number} [params.code] 错误码
 */


function info(params) {
  _report(extend(params, {
    level: INFO
  }));
}

function debug(params) {
  _report(extend(params, {
    level: DEBUG
  }));
}

export default {
  init: init,
  fatal: fatal,
  error: error,
  warn: warn,
  info: info,
  debug: debug,
  getMonitor: function getMonitor(pageId) {
    return Monitor.getMonitor(pageId);
  }
};